import React from 'react';

import Layout from '../components/Layout';
import Header from '../components/Header';
import Scroll from '../components/Scroll';
import Footer from '../components/Footer';
import Social from '../components/Social';
import Presentation from '../components/Presentation';
import CTA from '../components/CTA';

import demo1 from '../assets/images/demo-screen-1.jpg';
import gplay from '../assets/images/google-play-badge.svg';
import astore from '../assets/images/app-store-badge.svg';

import { Controller, Scene } from 'react-scrollmagic';
import { Tween, Timeline } from 'react-gsap';

const IndexPage = () => {
  return (
    <Layout>
      <Header />
      <header className="masthead">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-lg-7 my-auto">
              <div
                className="header-content mx-auto"
                data-sal="slide-right"
                data-sal-delay="100"
                data-sal-duration="900"
                data-sal-easing="ease"
              >
                <h1 className="mb-5">
                  The latest product in the app world. Creativity has never been so reachable.
                </h1>
                <Scroll type="id" element="download">
                  <a href="#download" className="btn btn-outline btn-xl">
                    READ MORE
                  </a>
                </Scroll>
              </div>
            </div>
            <div className="col-lg-5 my-auto">
              <div
                className="device-container"
                data-sal="slide-left"
                data-sal-delay="100"
                data-sal-duration="900"
                data-sal-easing="ease"
              >
                <div className="device-mockup iphone6_plus portrait white">
                  <div className="device">
                    <div className="screen">
                    <img src={demo1} className="img-fluid" alt="" />
                    </div>
                    <div className="button"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Controller>
          <Scene triggerElement="#arrow-trigger" offset="160">
            <Timeline>
              <Tween to={{ opacity: 0 }}>
                <div ref={el => (downArrow = el)} className="down-arrow">
                  <i className="fas fa-chevron-down"></i>
                </div>
                <div id="arrow-trigger"></div>
              </Tween>
            </Timeline>
          </Scene>
        </Controller>
      </header>

      <Presentation />

      <section className="features" id="features">
        <div className="container">
          <div className="section-heading text-center">
            <h2>Features and possibilities</h2>
            <p className="text-muted">See how it can benefit you</p>
            <hr />
          </div>
          <div className="row">
            <div className="col-lg-4 my-auto">
              <div className="device-container">
                <div className="device-mockup iphone6_plus portrait white">
                  <div className="device">
                    <div className="screen">
                      <img src={demo1} className="img-fluid" alt="" />
                    </div>
                    <div className="button"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 my-auto">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="feature-item">
                      <i className="icon-screen-smartphone text-primary"></i>
                      <h3>Usability Features</h3>
                      <p className="text-muted">
                        Ready to use it in any environment, at any time
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="feature-item">
                      <i className="icon-camera text-primary"></i>
                      <h3>Flexible and modern</h3>
                      <p className="text-muted">
                        Put an image, video, animation, or anything else in the
                        screen!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="feature-item">
                      <i className="icon-present text-primary"></i>
                      <h3>Free to Use</h3>
                      <p className="text-muted">
                        As always, this app is free to download and use it
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="feature-item">
                      <i className="icon-lock-open text-primary"></i>
                      <h3>Frequent updates</h3>
                      <p className="text-muted">
                        Our team works hard to provide you with the latest
                        updates, bug fixes and new features
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTA />

      <section className="download text-center" id="download">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <h2 className="section-heading">
                Download the app for free and begin integrating it in your work
                in minutes.
              </h2>
              <div className="badges">
                <a className="badge-link" href="/#">
                  <img src={gplay} alt="" className="google-play" />
                </a>
                <a className="badge-link" href="/#">
                  <img src={astore} alt="" className="app-store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact" id="contact">
        <div className="container">
          <h2>Contact</h2>
          <Social />
        </div>
      </section>

      <Footer />
    </Layout>
  );
};

export default IndexPage;
